import {
  createTrackingLinksFailure,
  createTrackingLinksRequest,
  createTrackingLinksSuccess,
  getTrackingLinksFailure,
  getTrackingLinksRequest,
  getTrackingLinksSuccess,
  removeTrackingLinksFailure,
  removeTrackingLinksRequest,
  removeTrackingLinksSuccess,
  updateTrackingLinksFailure,
  updateTrackingLinksRequest,
  updateTrackingLinksSuccess,
} from "./trackingLinkSlice";
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  createTrackingLinks,
  getTrackingLinks,
  removeTrackingLink,
  updateTrackingLink,
} from "./trackingLinkApi";
import { handleErrorSaga } from "../../utils/helper";

function* handleGetTrackingLinks({ payload }) {
  try {
    const res = yield call(getTrackingLinks, payload);
    yield put(getTrackingLinksSuccess(res.data));
  } catch (error) {
    yield put(getTrackingLinksFailure());
    yield handleErrorSaga(error);
  }
}

function* handleCreateTrackingLinks({ payload }) {
  try {
    const res = yield call(createTrackingLinks, payload);
    yield put(createTrackingLinksSuccess(res.data));
  } catch (error) {
    yield put(createTrackingLinksFailure());
    yield handleErrorSaga(error);
  }
}

function* handleUpdateTrackingLinks({ payload }) {
  try {
    const res = yield call(updateTrackingLink, payload);

    const temp = yield select(
      (state) => state.trackingLinksState.listTrackingLink
    );
    let data = [...temp];
    const index = data.findIndex((item) => item._id === payload._id);
    index >= 0 && (data[index] = { ...data[index], ...res.data });

    yield put(updateTrackingLinksSuccess([...data]));
  } catch (error) {
    yield put(updateTrackingLinksFailure());
    yield handleErrorSaga(error);
  }
}

function* handleRemoveTrackingLinks({ payload }) {
  try {
    yield call(removeTrackingLink, payload);

    const temp = yield select(
      (state) => state.trackingLinksState.listTrackingLink
    );
    let data = [...temp];
    const index = data.findIndex((item) => item._id === payload._id);
    index >= 0 && data.splice(index, 1);

    yield put(removeTrackingLinksSuccess([...data]));
  } catch (error) {
    yield put(removeTrackingLinksFailure());
    yield handleErrorSaga(error);
  }
}

export default function* trackingLinkSaga() {
  yield takeLatest(getTrackingLinksRequest.type, handleGetTrackingLinks);
  yield takeLatest(createTrackingLinksRequest.type, handleCreateTrackingLinks);
  yield takeLatest(updateTrackingLinksRequest.type, handleUpdateTrackingLinks);
  yield takeLatest(removeTrackingLinksRequest.type, handleRemoveTrackingLinks);
}
